var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4117 2.77045L3.47974 13.2831C3.10472 13.6823 2.7418 14.4686 2.66922 15.013L2.22162 18.9325C2.06435 20.3479 3.08053 21.3157 4.48382 21.0737L8.37915 20.4084C8.92353 20.3116 9.6857 19.9124 10.0607 19.5011L19.9926 8.98847C21.7104 7.17387 22.4847 5.10523 19.8112 2.57689C17.1497 0.0727449 15.1295 0.955849 13.4117 2.77045Z",
    stroke: "#008556",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7544 4.52466C12.2746 7.86352 14.9844 10.4161 18.3474 10.7547",
    stroke: "#008556",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 25.0295H22.7752",
    stroke: "#008556",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.02330c79378c44f1c7344ecc85a8c1a2.svg";
export { ForwardRef as ReactComponent };